import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/static/fonts/InterRegular/font.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22},{%22path%22:%22../../public/static/fonts/InterMedium/font.woff2%22,%22weight%22:%22500%22,%22style%22:%22normal%22},{%22path%22:%22../../public/static/fonts/InterSemiBold/font.woff2%22,%22weight%22:%22600%22,%22style%22:%22normal%22},{%22path%22:%22../../public/static/fonts/InterBold/font.woff2%22,%22weight%22:%22700%22,%22style%22:%22normal%22},{%22path%22:%22../../public/static/fonts/InterExtraBold/font.woff2%22,%22weight%22:%22800%22,%22style%22:%22normal%22}],%22display%22:%22swap%22,%22fallback%22:[%22Helvetica%22,%22Arial%22,%22sans-serif%22]}],%22variableName%22:%22inter%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'inter', 'inter Fallback', Helvetica, Arial, sans-serif",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
